module.exports = __webpack_public_path__ + "img/printer-outline.658ccaee.svg";